import { makeModuleStateSelector } from "@client/content/selectors";
import { TargetSelector, combinedSettingsSelector, createShallowEqualSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type Leaderboard } from "./types";

export const localStateSelector = makeModuleStateSelector<Leaderboard.AppState>(defaultState, previewState);

export const localStateCurrentSelector = createSelector([localStateSelector], (ls) => ls.current);
export const localStateHasMoreSelector = createSelector([localStateSelector], (ls) => ls.hasMore);
export const localStateCountryCodeSelector = createSelector([localStateSelector], (ls) => ls.countryCode);
export const localStateItemsSelector = createSelector([localStateSelector], (ls) => ls.items);
export const localStateRewardsSelector = createSelector([localStateSelector], (ls) => ls.rewards);

export const makeSourceIdSelector = () => {
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["type", "incentiveId", "launchId"]);

  return createShallowEqualSelector([settingsSelector], (settings): string | null =>
    settings.type === "incentive" ? settings.incentiveId : settings.launchId
  );
};
